import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  initialValues,
  validationSchema,
} from "../../componentes/ActivarCuenta/ActivarCuenta.Form";
import "../../scss/index.scss";
import imaLogo from "../../imagenes/logo.png";
import { Grid, Header, Image, Segment, Form } from "semantic-ui-react";
import { useFormik } from "formik";

import {
  activar_cuenta,
  codigo_de_activacion,
  ingresa_el_codigo_de_activacion,
  reenviar_codigo_de_activacion,
} from "../../utils/traductor";
import { apiUsuario } from "../../api/usuario";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { ENTORNO, HabilitarGoogleRecaptcha } from "../../utils/constantes";
import { setmenuAbajoSeleccionado } from "../../utils/variablesLocales";
import { estiloSegmento } from "../../estilos";
import { TextField } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import { apigoogleRecaptchaV3 } from "../../api";
import ReactRecaptcha3 from "react-google-recaptcha3";

//////////////////////////////////////////////////////////

const apigooglerecaptchav3 =
  HabilitarGoogleRecaptcha === true ? new apigoogleRecaptchaV3() : null;
const apiusuario = new apiUsuario();

const ValidarTokenRecaptcha = async (
  tokenGoogleRecaptchaV3,
  ipPublicaValor,
  codigoactivacion,
  navigateToInicioPasajero
) => {
  if (HabilitarGoogleRecaptcha) {
    const respuestaVerificacionRecaptcha = await apigooglerecaptchav3.verificar(
      tokenGoogleRecaptchaV3,
      ipPublicaValor
    );

    if (respuestaVerificacionRecaptcha === true) {
      IngresarConfirmar(codigoactivacion, navigateToInicioPasajero);
    } else {
    }
  } else {
    IngresarConfirmar(codigoactivacion, navigateToInicioPasajero);
  }
};

const IngresarConfirmar = async (
  codigoactivacion,
  navigateToInicioPasajero
) => {
  const response = await apiusuario.activarCuenta(codigoactivacion);

  Swal.fire({
    title: "",
    text: response.Mensaje,
    icon: "success",
    confirmButtonText: "Ok",
    confirmButtonColor: estiloColores.Azul,
  }).then(function () {
    //destruir el recaptcha
    if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

    navigateToInicioPasajero();
  });
};

export function ActivarCuenta() {
  const navigate = useNavigate();

  const navigateToInicioPasajero = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  const navigateToEscribirEmail = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/OlvidoSuClave");
  };

  const navigateToReenviarCodigoActivacion = () => {
    navigate(ENTORNO.URL_APLICACION + "/ReenviarCodigoActivacion");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        //validacion google recaptcha v3
        //1. calculo ip publica
        const ipPublica = require("react-public-ip");
        const ipPublicaValor = (await ipPublica.v4()) || "";

        //2. obtengo token
        if (HabilitarGoogleRecaptcha) {
          ReactRecaptcha3.getToken().then(
            (tokenGoogleRecaptchaV3) => {
              ValidarTokenRecaptcha(
                tokenGoogleRecaptchaV3,
                ipPublicaValor,
                formik.values.codigoactivacion,
                navigateToInicioPasajero
              );
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          IngresarConfirmar(
            formik.values.codigoactivacion,
            navigateToInicioPasajero
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  useEffect(() => {
    if (HabilitarGoogleRecaptcha) {
      ReactRecaptcha3.init(ENTORNO.GOOGLE_RECAPTCHA_V3_SITEKEY).then(
        (status) => {}
      );
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              {/* <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToEscribirEmail}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <ArrowBackIcon fontSize="medium" />
            </IconButton> */}
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {activar_cuenta}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Segment style={estiloSegmento.Pasajero}>
              <Grid textalign="center" container style={{ padding: "5em 0em" }}>
                <Grid.Row>
                  <div className="ingresar">
                    <Grid.Column style={{ maxWidth: 450 }}>
                      <Image
                        src={imaLogo}
                        className="logoCrearCuenta"
                        centered
                      />
                      <Header as="h3">{activar_cuenta}</Header>
                      {/* <form
                      size="large"
                      textalign="center"
                      onSubmit={formik.handleSubmit}
                    > */}
                      <Box
                        //component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: "25ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <label>{ingresa_el_codigo_de_activacion}</label>
                        <br></br>
                        <TextField
                          id="codigoactivacion"
                          label={codigo_de_activacion}
                          placeholder={codigo_de_activacion}
                          variant="standard"
                          name="codigoactivacion"
                          size="large"
                          type="text"
                          icon="key"
                          value={formik.values.codigoactivacion}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.codigoactivacion &&
                            Boolean(formik.errors.codigoactivacion)
                          }
                          helperText={
                            formik.touched.codigoactivacion &&
                            formik.errors.codigoactivacion
                          }
                        />
                      </Box>
                      <br></br>
                      <br></br>
                      <br></br>
                      <small>
                        <label onClick={navigateToReenviarCodigoActivacion}>
                          {reenviar_codigo_de_activacion}
                        </label>
                      </small>
                    </Grid.Column>
                  </div>
                </Grid.Row>
              </Grid>
            </Segment>
          </Container>
        </React.Fragment>
      </form>
    </div>
  );
}
